module.exports = (__webpack_public_path__ || '') + "static/images/photo-11-18a9321b892f1502a9f5528be6a0c7cf.jpg";